export default __webpack_public_path__ + "eef12f08c7da843e638fd9c200d9a899.png";